module.exports = __webpack_public_path__ + "media/head.4295e05f.mp4";